import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface ILegalHistoryModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    LegalJusticeInvolvement: string;
    IsAILegalJusticeInvolvement: boolean;
    YesAsJuvenile: boolean;
    YesPastNoIncarceration: boolean;
    YesOnProbataionNoIncarceration: boolean;
    YesOnProbataionNoIncarcerationDetails: string;
    YesPreviouslyIncarceratedNotOnParole: boolean;
    YesPreviouslyIncarceratedOnParole: boolean;
    YesPreviouslyIncarceratedOnParoleDetails: string;
    YesCurrentlyChargedWarrents: boolean;
    No: boolean;
    LegalHistoryComments: string;
    HasCOT: string;
    IsAIHasCOT: boolean;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
}

export class LegalHistoryModel implements ILegalHistoryModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    LegalJusticeInvolvement: string;
    IsAILegalJusticeInvolvement: boolean;
    YesAsJuvenile: boolean;
    YesPastNoIncarceration: boolean;
    IsAIYesPastNoIncarceration: boolean;
    YesOnProbataionNoIncarceration: boolean;
    YesOnProbataionNoIncarcerationDetails: string;
    YesPreviouslyIncarceratedNotOnParole: boolean;
    YesPreviouslyIncarceratedOnParole: boolean;
    YesPreviouslyIncarceratedOnParoleDetails: string;
    YesCurrentlyChargedWarrents: boolean;
    No: boolean;
    LegalHistoryComments: string;
    HasCOT: string;
    IsAIHasCOT: boolean;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.IsAILegalJusticeInvolvement = false;
        this.YesAsJuvenile = false;
        this.YesPastNoIncarceration = false;
        this.YesOnProbataionNoIncarceration = false;
        this.YesPreviouslyIncarceratedNotOnParole = false;
        this.YesPreviouslyIncarceratedOnParole = false;
        this.YesCurrentlyChargedWarrents = false;
        this.No = false;
        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
        this.IsAIHasCOT = false;
    }
}
